export const supermarkets = [
  {
    name: "Supermercado Centerbox",
    image: "https://storage.readdy-site.link/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/10d33f6c-d591-4617-b26d-58a944c82ca9_compressed_Captura-de-tela-2026-07-17-155043.webp",
  },
  {
    name: "Supermercado Anali",
    image: "https://storage.readdy-site.link/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/bc7a90d5-6e42-4ea9-a4f6-6fbbf5d57e06_compressed_Captura-de-tela-2026-07-17-155125.webp",
  },
  {
    name: "Supermercado Sao Luis",
    image: "https://storage.readdy-site.link/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/c681e8f7-ae3c-41cf-8408-0d046382a61b_compressed_Captura-de-tela-2026-07-17-155201.webp",
  },
  {
    name: "Supermercado Carnauba",
    image: "https://storage.readdy-site.link/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/160127f3-4bb1-4a38-b8ed-5c8467d5f481_compressed_Captura-de-tela-2026-07-17-155338.webp",
  },
  {
    name: "Supermercado Cometa",
    image: "https://storage.readdy-site.link/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/cb915b73-82ba-4c10-ba73-3f1b43d91029_compressed_Captura-de-tela-2026-07-17-155440.webp",
  },
  {
    name: "Supermercado R Center",
    image: "https://storage.readdy-site.link/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/62601cc4-2252-4289-9bef-21b4c5f2579a_compressed_Captura-de-tela-2026-07-17-155505.webp",
  },
  {
    name: "Supermercado Lagoa",
    image: "https://storage.readdy-site.link/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/553dcc15-e1d0-44ee-85d0-54f8ef310ccd_compressed_Captura-de-tela-2026-07-17-155535.webp",
  },
  {
    name: "Supermercado Pinheiro",
    image: "https://storage.readdy-site.link/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/025b6625-de3c-41cd-9e80-3e957aeff9c4_compressed_Captura-de-tela-2026-07-17-155547.webp",
  },
];